import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography,  Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchCategories } from '../services/Apis';



const PopularCategoryAll = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getCategories = async () => {
      const data = await fetchCategories();
      const filtered = data.filter(cat => cat.isPopular === true ).map((cat, idx) => ({ ...cat,
        image: cat.imageUrl || null,
      }));
      setCategories(filtered);
    };
    getCategories();
  }, []);


  const handleCat = (cat) => {
    navigate(`/examwise-books?cat=${cat.id || cat.title}`);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 5 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h3" sx={{ fontWeight: 600, fontFamily: 'Poppins', color: '#CB4422', borderLeft: '4px solid #CB4422', paddingLeft: 1 }}>Popular Categories</Typography>
      </Box>
      <Grid container spacing={3}>
        {categories.map((category, index) => (
          <Grid  size={{xs:12,sm:6,md:4,lg:3}} key={index}>
            <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', boxShadow: 1, cursor: 'pointer', transition: 'transform 0.3s ease-in-out', '&:hover': { transform: 'scale(1.03)' } }}>
              <img loading="lazy" src={category.image} alt={category.name || category.title}
                style={{ 
                  // width: '250px',
                  width:'100%', minHeight: '200px', maxHeight: '200px', objectFit: 'cover' }} onClick={() => handleCat(category)}
              />
              <Box sx={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'primary.main', textAlign: 'center', py: 1.5 }}>
                <Typography sx={{ color: '#fff', fontFamily: 'Poppins', fontWeight: 600, fontSize: 14 }}>
                  {category.name || category.title}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default PopularCategoryAll;